"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagBanks = exports.FeatureFlagPlatform = void 0;
var FeatureFlagPlatform;
(function (FeatureFlagPlatform) {
    FeatureFlagPlatform["WEB"] = "WEB";
    FeatureFlagPlatform["ANDROID"] = "ANDROID";
    FeatureFlagPlatform["IOS"] = "IOS";
    FeatureFlagPlatform["CC"] = "CC";
    FeatureFlagPlatform["BRANCH"] = "BRANCH";
})(FeatureFlagPlatform || (exports.FeatureFlagPlatform = FeatureFlagPlatform = {}));
var FeatureFlagBanks;
(function (FeatureFlagBanks) {
    FeatureFlagBanks["BANK_AR"] = "OPENBANK_AR";
    FeatureFlagBanks["BANK_DE"] = "OPENBANK_DEU";
    FeatureFlagBanks["BANK_ES"] = "OPENBANK_ES";
    FeatureFlagBanks["BANK_MX"] = "OPENBANK_MX";
    FeatureFlagBanks["BANK_NL"] = "OPENBANK_NL";
    FeatureFlagBanks["BANK_PT"] = "OPENBANK_PT";
    FeatureFlagBanks["BANK_US"] = "SB_US";
    FeatureFlagBanks["BANK_CO"] = "SB_CO";
    FeatureFlagBanks["DCP"] = "DCP";
    FeatureFlagBanks["SANTANDER_BANK_MX"] = "SB_MX";
    FeatureFlagBanks["SANTANDER_BANK_BR"] = "SB_BR";
    FeatureFlagBanks["SANTANDER_BANK_ES"] = "SB_ES";
    FeatureFlagBanks["SANTANDER_BANK_PL"] = "SB_PL";
    FeatureFlagBanks["SANTANDER_BANK_UY"] = "SB_UY";
})(FeatureFlagBanks || (exports.FeatureFlagBanks = FeatureFlagBanks = {}));
//# sourceMappingURL=types.js.map